import PropTypes from 'prop-types';
import React, { Component } from 'react';
import NotificationSystem from 'react-notification-system';
import { BeatLoader } from 'react-spinners';
import { _addNotificationError, getLastMonthStartEndDates, getMonthStartEndDates, getSessionStartEndDates, getTodayStartEndDates, getWeekStartEndDates, showFile } from '../../../../server/util';
import { get } from '../../../../server/actions';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import './../../../../../node_modules/react-datetime/css/react-datetime.css';
import AccountHistory from './AccountHistory';
import StudentPurchaseReport from './StudentPurchaseReport';

class StudentAccount extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: "accountHistory",
            loading: false,
            mealSchoolId: 0,
            loading: false,
            accountHistory: [],
            purchaseData: [],
            id: 0,
            studentFName: '',
            studentLName: '',
            hdataFilter: { id: '', tdate: 'D', sdate: new Date(), edate: new Date() }
        };
    }
    componentWillMount = () => {
        const { id } = this.context.router.route.match.params;
        const { schoolId } = this.context.router.route.location.state;
        this.setState({ id: id, mealSchoolId: schoolId }, () => {
            this.bindData(id);
        });
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    }
    bindData = (id, isPdf = false) => {
        if (this.state.activeTab === "purchases") {
            this.getPurchaseData(id, isPdf);
        } else {
            this.getAccountHistoryData(id, isPdf);
        }
    }
    getPurchaseData = (id, isPdf = false) => {
        let _self = this;
        let userInfo = {};
        if ((sessionStorage.getItem('ROLE')) === "ROLE_ADMIN") {
            userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        }
        let date = {}
        if (this.state.hdataFilter.tdate === 'W') {
            date = getWeekStartEndDates(new Date())
        } else if (this.state.hdataFilter.tdate === 'M') {
            date = getMonthStartEndDates(new Date())
        } else if (this.state.hdataFilter.tdate === 'LM') {
            date = getLastMonthStartEndDates(new Date())
        } else if (this.state.hdataFilter.tdate === 'Y') {
            date = getSessionStartEndDates(sessionStorage.getItem('schoolYearValue'))
        } else if (this.state.hdataFilter.tdate === 'C') {
            date = { startDate: this.state.hdataFilter.sdate, endDate: this.state.hdataFilter.edate }
        } else {
            date = getTodayStartEndDates(new Date())
        }
        this.setState({ loading: true });
        get('/reports/stdPurchaseTransactions/' + id + '?startDate=' + moment(date.startDate).utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(date.endDate).utc().format("YYYY-MM-DDTHH:mm:ss") + '&isExport=' + isPdf + '&access_token=').then((response) => {
            if (!response.ok) {
                if (response.status === 417) {
                    return response.json();
                }
                //throw Error(response.errorMessage);
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                // _addNotificationError(res.statusMessage,this)
                throw Error(res.statusMessage);
            } else if (!res.statusCode === 200) {
                throw Error(res.errorMessage);
            } else {
                if (isPdf) {
                    return res.blob();
                } else {
                    return res.json();
                }
            }
        }).then(data => {
            if (isPdf) {
                let filename = (this.state.studentFName + ' ' + this.state.studentLName) + '_purchaseReport.pdf';
                showFile(data, filename);
                this.setState({ loading: false });
            } else {
                this.setState({
                    purchaseData: (data.resp || []), loading: false,
                    // studentFName: data.studentAccountDetails.studentFName, studentLName: data.studentAccountDetails.studentLName
                })
            }
        }).catch(
            (error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, _self)
                //console.log('Get Excel File response', error)
                this.setState({ loading: false })
            }
        );

    }
    getAccountHistoryData = (id, isPdf = false) => {
        let _self = this;
        let userInfo = {};
        if ((sessionStorage.getItem('ROLE')) === "ROLE_ADMIN") {
            userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        }
        let date = {}
        if (this.state.hdataFilter.tdate === 'W') {
            date = getWeekStartEndDates(new Date())
        } else if (this.state.hdataFilter.tdate === 'M') {
            date = getMonthStartEndDates(new Date())
        } else if (this.state.hdataFilter.tdate === 'LM') {
            date = getLastMonthStartEndDates(new Date())
        } else if (this.state.hdataFilter.tdate === 'Y') {
            date = getSessionStartEndDates(sessionStorage.getItem('schoolYearValue'))
        } else if (this.state.hdataFilter.tdate === 'C') {
            date = { startDate: this.state.hdataFilter.sdate, endDate: this.state.hdataFilter.edate }
        } else {
            date = getTodayStartEndDates(new Date())
        }
        this.setState({ loading: true });
        get('/reports/transactionsHistory?studentRecId=' + id + '&startDate=' + moment(date.startDate).utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(date.endDate).utc().format("YYYY-MM-DDTHH:mm:ss") + '&fileExport=' + isPdf + '&access_token=').then((response) => {
            if (!response.ok) {
                if (response.status === 417) {
                    return response.json();
                }
                //throw Error(response.errorMessage);
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                // _addNotificationError(res.statusMessage,this)
                throw Error(res.statusMessage);
            } else if (!res.statusCode === 200) {
                throw Error(res.errorMessage);
            } else {
                if (isPdf) {
                    return res.blob();
                } else {
                    return res.json();
                }
            }
        }).then(data => {
            if (isPdf) {
                let filename = (this.state.studentFName + ' ' + this.state.studentLName) + '_AccountHistory.pdf';
                showFile(data, filename);
                this.setState({ loading: false });
            } else {
                console.log(JSON.stringify(data.studentAccountDetails.accountTransactionHistories));
                this.setState({
                    accountHistory: (data.studentAccountDetails || {}).accountTransactionHistories || [], loading: false,
                    studentFName: data.studentAccountDetails.studentFName, studentLName: data.studentAccountDetails.studentLName
                })
            }
        }).catch(
            (error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, _self)
                //console.log('Get Excel File response', error)
                this.setState({ loading: false })
            }
        );
    }
    render() {
        const { activeTab, accountHistory, mealSchoolId, purchaseData } = this.state;
        return (
            <section className="full-width clearfix">
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading'
                    style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="container ">
                    <div className="sectionTitle">
                        <div className="row">
                            <div className='col-md-6'>
                                <h2 id="deleteLabel">{(activeTab == 'purchases' ? "Purchases :" : "Account History :") + this.state.studentFName + ' ' + this.state.studentLName}
                                </h2>
                            </div>
                            <div className='col-md-6 text-right'>
                                <div className="btn-group">
                                    <button className={activeTab === "accountHistory" ? "btn btn-xs btn-inactive-color active" : "btn btn-xs btn-inactive-color"} onClick={() => this.setState({ activeTab: 'accountHistory' }, () => {
                                        this.bindData(this.state.id);
                                    })}>Account History</button>
                                    <button className={activeTab === "purchases" ? "btn btn-xs btn-inactive-color active" : "btn btn-xs btn-inactive-color"} onClick={() => this.setState({ activeTab: 'purchases' }, () => {
                                        this.bindData(this.state.id);
                                    })}>Purchases</button>
                                </div>
                                <button className="btn bg-color-4" style={{ margin: '0px', color: '#ffffff' }} onClick={(e) => {
                                    e.preventDefault();
                                    let _self = this;
                                    _self.context.router.history.goBack();
                                }}><i class="fa fa-arrow-circle-left" aria-hidden="true"></i> Back</button>
                            </div>


                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="alert alert-info" style={{ padding: '5px', marginBottom: '5px' }} >
                                <div onChange={(event) => {
                                    let hdataFilter = this.state.hdataFilter;
                                    hdataFilter.tdate = event.target.value;
                                    this.setState({ hdataFilter: hdataFilter })
                                    if (event.target.value !== "C") {
                                        this.bindData(this.state.id, false);
                                    }
                                }}>
                                    <label class="rbcontainer">Today
                                        <input type="radio" name="hdrange" value="D" defaultChecked={this.state.hdataFilter.tdate === 'D'} />
                                        <span className="rbcheckmark"></span>
                                    </label>
                                    <label class="rbcontainer">This Week
                                        <input type="radio" name="hdrange" value="W" defaultChecked={this.state.hdataFilter.tdate === 'W'} />
                                        <span className="rbcheckmark"></span>
                                    </label>
                                    <label class="rbcontainer">This Month
                                        <input type="radio" name="hdrange" value="M" defaultChecked={this.state.hdataFilter.tdate === 'M'} />
                                        <span className="rbcheckmark"></span>
                                    </label>
                                    <label class="rbcontainer">Last Month
                                        <input type="radio" name="hdrange" value="LM" defaultChecked={this.state.hdataFilter.tdate === 'LM'} />
                                        <span className="rbcheckmark"></span>
                                    </label>
                                    <label class="rbcontainer">This Year
                                        <input type="radio" name="hdrange" value="Y" defaultChecked={this.state.hdataFilter.tdate === 'Y'} />
                                        <span className="rbcheckmark"></span>
                                    </label>
                                    <label class="rbcontainer">Custom Dates
                                        <input type="radio" name="hdrange" value="C" defaultChecked={this.state.hdataFilter.tdate === 'C'} />
                                        <span className="rbcheckmark"></span>
                                    </label>
                                    {
                                        this.state.hdataFilter.tdate === 'C' ?
                                            <DateRangePicker onApply={(event, picker) => {
                                                let hdataFilter = this.state.hdataFilter;
                                                hdataFilter.sdate = picker.startDate._d;
                                                hdataFilter.edate = picker.endDate._d;
                                                this.setState({ hdataFilter: hdataFilter })
                                                console.log('sdate --:', event, picker)
                                                this.bindData(this.state.id, false);
                                            }}>
                                                <button className="btn btn-xs bg-color-1" style={{ margin: '0px', minWidth: '20px' }}><i className="fa fa-calendar"></i></button>
                                            </DateRangePicker> : null
                                    }
                                    <a title="Click to Download PDF"
                                        onClick={() => { this.bindData(this.state.id, true) }//this.quickReports('Pdf','currentDay')
                                        } target='_blank'
                                        className="fa fa-file-pdf-o fa-2x QuickReports-PDF pull-right"><i /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-12'>
                            {activeTab === "accountHistory" && <div>
                                <AccountHistory accountHistoryData={accountHistory} mealSchoolId={mealSchoolId} />
                            </div>}
                            {activeTab === "purchases" && <div>
                                <StudentPurchaseReport purchaseData={purchaseData} mealSchoolId={mealSchoolId} /></div>}
                        </div>
                    </div>
                </div>
            </section >
        );
    }
}
StudentAccount.contextTypes = {
    router: PropTypes.object.isRequired
}

export default StudentAccount;


// WEBPACK FOOTER //
// ./src/components/Parent/Home/StudentAccount/index.js